import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createListReduceObject } from '../../../../../common/reducers/list/reducer';

import eventsNotReadUserNoticesListSaga from './sagas/eventsNotReadUserNoticesListSaga';
import eventsUserNoticesListSaga from './sagas/eventsUserNoticesListSaga';

export default [
  // Lists
  ...createCombineMapItem(
    'eventsNotReadUserNoticesList',
    createListReduceObject,
    [eventsNotReadUserNoticesListSaga]
  ),
  ...createCombineMapItem('eventsUserNoticesList', createListReduceObject, [
    eventsUserNoticesListSaga
  ])
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/events/reducers/static/lists/reducersMap.js